import React, { ReactNode } from "react";
import { useFormContext } from "react-hook-form";
import { type AutocompleteRenderOptionState, Form } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { GROUP_ROLE_DETAILS } from "Constants";
import { GroupRole } from "Types";
import styles from "./groupRoleAutocomplete.module.scss";

const renderOption = (
  props: React.HTMLAttributes<HTMLLIElement>,
  option: GroupRole,
  { selected }: AutocompleteRenderOptionState,
): ReactNode => {
  const findOption = GROUP_ROLE_DETAILS[option];
  const cls = getClassName(styles["select-role"], {
    [styles["select-role-selected"]]: selected,
  });

  return (
    <li {...props} className={cls}>
      <div>
        {findOption?.label}
        <br />
        <Form.HelperText>{findOption?.helperText}</Form.HelperText>
      </div>
    </li>
  );
};

const GroupRoleAutocomplete = (props: {
  id?: string;
  isRequired?: boolean;
}): React.JSX.Element | null => {
  const {
    formState: { errors },
  } = useFormContext<{ orgRole: string; groupRole: string }>();

  return (
    <Form.Autocomplete
      {...props}
      name="groupRole"
      label="Group role"
      errors={errors}
      multiSelect={false}
      isClearable={false}
      options={Object.keys(GROUP_ROLE_DETAILS) as GroupRole[]}
      renderOption={renderOption}
      getOptionLabel={(option) =>
        GROUP_ROLE_DETAILS[option as GroupRole]?.label ?? ""
      }
    />
  );
};

export default GroupRoleAutocomplete;
